export default __webpack_public_path__ + "static/media/Sanya-3.84e11e59.mp4";